type PaymentRedirectMessage = {
  paymentLink: string;
  paymentCode?: string;
};

export const redirectToPayment = (message: PaymentRedirectMessage) => {
  if (window.parent === window) {
    window.location.assign(message.paymentLink);
    return;
  }

  window.parent.postMessage(message, "*");
};
